import React from 'react';
import { HiArrowNarrowRight } from 'react-icons/hi';
import { MdArrowForwardIos, MdOutlineArrowBackIosNew } from 'react-icons/md';
import { Button, Col, Label, Row } from 'reactstrap';

const Summary = ({
  index,
  trader,
  totalQty,
  validityInHours,
  offerType,
  grade,
  handlePrevNext,
  max,
  buttonDisabled,
}) => {
  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        {buttonDisabled && (
          <Button
            className="text-decoration-none px-0"
            type="button"
            color="link"
            onClick={(e) => handlePrevNext(e, 'prev')}
            disabled={index <= 0}
          >
            <MdOutlineArrowBackIosNew
              size={16}
              className="me-2"
              color="#525252"
            />
          </Button>
        )}
        <h4 className="f-16 fw-semibold">{grade?.name}</h4>
        {buttonDisabled && (
          <Button
            className="text-decoration-none px-0"
            color="link"
            type="button"
            onClick={(e) => handlePrevNext(e, 'next')}
            disabled={index === max - 1}
          >
            <MdArrowForwardIos size={16} color="#525252" />
          </Button>
        )}
      </div>
      <div>
        <div className="border p-3 rounded mt-2">
          <Row className="justify-content-between">
            <Col sm={3}>
              <Label className="f-12 fw-medium text-gray text-uppercase  d-block mb-0 form-label">
                Seller
              </Label>
              <p className="f-14 mb-0 font-manrope fw-semibold">
                {trader?.firstName}
              </p>
            </Col>
            <Col>
              <Label className="f-12 fw-medium text-gray text-uppercase d-block mb-0 form-label">
                Validity(Hours)
              </Label>
              <p className="f-14 mb-0 font-manrope fw-semibold">
                {validityInHours}
              </p>
            </Col>
            <Col>
              <Label className="f-12 fw-medium text-gray text-uppercase d-block mb-0 form-label">
                Offer Type
              </Label>
              <p className="f-14 mb-0 font-manrope fw-semibold">{offerType}</p>
            </Col>
            <Col>
              <Label className="f-12 fw-medium text-gray text-uppercase d-block mb-0 form-label">
                Location
              </Label>
              <p className="f-14 mb-0 font-manrope fw-semibold">Mumbai</p>
            </Col>
            <Col>
              <Label className="f-12 fw-medium text-gray text-uppercase d-block mb-0 form-label">
                Total Quantity
              </Label>
              <p className="f-14 mb-0 font-manrope fw-semibold">{totalQty}</p>
            </Col>
            <Col className="text-end">
              <Button
                color="link"
                className="text-decoration-none text-nowrap font-manrope f-12 fw-bold text-dark-525 p-0"
              >
                View more <HiArrowNarrowRight className="ms-1" />
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default Summary;
